import { track } from '@mobi/account/Utils/analytics'

export type SignUpAnalyticsKeys =
  | 'sign-up-already-have-account'
  | 'sign-up-start'
  | 'sign-up-join'
  | 'sign-up-deposit-click'
  | 'sign-up-complete'
  | 'sign_up_deposit_limits_skipped'
  | 'sign_up_error'
  | 'sign-up-go-back-home-page'

const SIGN_UP_ALREADY_HAVE_ACCOUNT: SignUpAnalyticsKeys = 'sign-up-already-have-account'
const SIGN_UP_START: SignUpAnalyticsKeys = 'sign-up-start'
const SIGN_UP_JOIN: SignUpAnalyticsKeys = 'sign-up-join'
const SIGN_UP_DEPOSIT_CLICK: SignUpAnalyticsKeys = 'sign-up-deposit-click'
const SIGN_UP_COMPLETE: SignUpAnalyticsKeys = 'sign-up-complete'
const SIGN_UP_DEPOSIT_LIMITS_SKIPPED: SignUpAnalyticsKeys = 'sign_up_deposit_limits_skipped'
const SIGN_UP_ERROR: SignUpAnalyticsKeys = 'sign_up_error'
const SIGN_UP_GO_BACK_HOME: SignUpAnalyticsKeys = 'sign-up-go-back-home-page'

export const trackSignUpAlreadyHaveAccount = (signUpStarted: boolean) =>
  track(SIGN_UP_ALREADY_HAVE_ACCOUNT, { signUpStarted })
export const trackSignUpStart = () => track(SIGN_UP_START)
export const trackSignUpJoin = (
  addressMethod: 'auto' | 'manual' | null,
  marketingConsent: boolean
) => track(SIGN_UP_JOIN, { addressMethod: addressMethod ?? undefined, marketingConsent })
export const trackSignUpDepositClick = (offerStatus: boolean) =>
  track(SIGN_UP_DEPOSIT_CLICK, { offerStatus })
export const trackSignUpComplete = () => track(SIGN_UP_COMPLETE)
export const trackSignUpDepositLimitsSkipped = () => track(SIGN_UP_DEPOSIT_LIMITS_SKIPPED)
export const trackSignUpError = (location: string, message: string) =>
  track(SIGN_UP_ERROR, { location, message })
export const trackSignUpGoBackHomePage = (location: string) =>
  track(SIGN_UP_GO_BACK_HOME, { location })
